import styled from 'styled-components';
import ReactTooltip from 'react-tooltip';

const StyledReactTooltip = styled(ReactTooltip)`
  opacity: 1 !important;
`;

export default StyledReactTooltip;
